/**
 * CUSTOM KIYO — kiyo-menu-offset.js
 *
 * Keeps the close "X" of the mobile menu on the height of the burger icon while
 * the announcement bar scrolls away. kiyo-header.css consumes the result:
 *   padding-top: calc(79px - var(--kiyo-menu-shift, 0px))
 *
 * The shift is derived from the announcement bar, not from the burger: the bar is
 * neither sticky nor fixed, so its top edge equals -scrollY at any time, menu open
 * or closed (the burger sits in the sticky header, which the theme's scroll lock
 * un-sticks). Overscroll (barTop > 0) clamps to 0, nothing is frozen or remembered.
 *   shift = clamp(-barTop, 0, barHeight + STICKY_EXTRA)
 * Measured 2026-09-07: burger 79.6px at rest, constant 16.2px once the header
 * sticks = bar height 57.4px + 6px. See THEME-CHANGES.md (2026-09-07) for the history.
 */
(() => {
  const DRAWER = '.menu-drawer-container .menu-drawer';
  const DETAILS = '#Details-menu-drawer-container';
  const BAR = '.announcement-bar';
  // header margin-top on mobile (5px, kiyo-header.css) + sticky offset of the header section (1px, theme "top: -1px")
  const STICKY_EXTRA = 6;

  let frame = null;

  const sync = () => {
    frame = null;
    const drawer = document.querySelector(DRAWER);
    const barInner = document.querySelector(BAR);
    const bar = barInner?.closest('.shopify-section') || barInner;
    if (!drawer || !bar) return;
    const rect = bar.getBoundingClientRect();
    if (!rect.height) return;
    const shift = Math.min(rect.height + STICKY_EXTRA, Math.max(0, -rect.top));
    // On <html>, not on the drawer: the header section gets re-rendered after load
    // and would drop an inline style; custom properties inherit.
    document.documentElement.style.setProperty('--kiyo-menu-shift', `${Math.round(shift)}px`);
  };

  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(sync);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);

  // Re-measure when the drawer opens/closes (`toggle` does not bubble -> capture).
  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target instanceof HTMLDetailsElement && event.target.matches(DETAILS)) {
        schedule();
        setTimeout(sync, 400);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();
